import axios from 'axios'
import AuthService from '@/services/auth.service'
import $const from '@/utils/const'

const UserService = {
    getJwtUser ({
        code,
        state,
        sessionState
    }) {
        const provider = JSON.parse(sessionStorage.getItem($const.sessionStorageKey.provider))
        let url = process.env.VUE_APP_BASE_API_V4_URL + `/jwt-auth/jwt_user/${provider.name}/`
        let instance = axios.create({
            headers: {
                common: {
                    'Content-Type': 'application/json'
                }
            }
        })
        return instance.post(url, {
            code,
            state,
            session_state: sessionState,
            redirect_uri: AuthService.getAuthenticationSuccessUrl()
        })
    },
    getProfile () {
        return window.$http.get('/jwt-auth/profile/')
    }
}

export default UserService
